import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetTodaysRoutes = () =>
  useMutation({
    mutationFn: () => client(`maintenance/services/today/rosters`),
  });
export const useAssignFieldTeam = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/assign/field/team`, {
        data,
        successMessage: "Team has been assigned successfully",
      }),
  });
export const useSelfAssign = () =>
  useMutation({
    mutationFn: (requestId) =>
      client(`maintenance/services/self/assign/${requestId}`, {
        method: "post",
        successMessage: "Self assigned successfully",
      }),
  });
export const useAddNotes = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/add/notes`, {
        data,
        successMessage: "Notes has been added successfully",
      }),
  });
export const useGetRequestDetails = () =>
  useMutation({
    mutationFn: (requestId) =>
      client(`maintenance/services/request/details/${requestId}`),
  });
export const useGetRoutes = () =>
  useMutation({
    mutationFn: (data) => client(`maintenance/services/area/routes`, { data }),
  });
export const useUpdateRoutesTeam = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/update/route/field/team`, {
        data,
        successMessage: "Route has been assigned successfully",
      }),
  });
export const useGetAllRequests = () =>
  useMutation({
    mutationFn: (data) => client("maintenance/services/all", { data }),
  });

export const useExportAllRequests = () =>
  useMutation({
    mutationFn: (data) => client(`maintenance/services/export/all`, { data }),
  });

export const useGetOpenRequests = () =>
  useMutation({
    mutationFn: (data) => client(`maintenance/services/user/open`, { data }),
  });
export const useExportOpenRequests = () =>
  useMutation({
    mutationFn: (data) => client(`maintenance/services/export/open`, { data }),
  });
export const useGetAssignedRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/user/assigned`, { data }),
  });
export const useExportAssignedRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/export/assigned`, { data }),
  });
export const useGetGunneboRequests = () =>
  useMutation({
    mutationFn: (data) => client(`maintenance/services/gunebo`, { data }),
  });
export const useExportGunneboRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/export/gunebo`, { data }),
  });
export const useGetNonGunneboRequests = () =>
  useMutation({
    mutationFn: (data) => client(`maintenance/services/non/gunebo`, { data }),
  });
export const useExportNonGunneboRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/export/non/gunebo`, { data }),
  });
export const useGetSelfMaintenanceRequests = () =>
  useMutation({
    mutationFn: (data) => client("maintenance/services/my/requests", { data }),
  });

export const useGetClosedRequests = () =>
  useMutation({
    mutationFn: (data) => client("maintenance/services/closed", { data }),
  });

export const useExportClosedRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client("maintenance/services/export/closed", { data }),
  });

export const useMaintenanceBulkAssign = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/route/bulk/assign`, {
        data,
        successMessage: "Bulk assignment successful",
      }),
  });

export const useAddTask = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/add/task`, {
        data,
        successMessage: "Task has been added successfully",
      }),
  });

export const useUpdateMaintenanceStatus = () =>
  useMutation({
    mutationFn: (data) =>
      client(`maintenance/services/update/status`, {
        data,
        successMessage: "Task has been updated successfully",
      }),
  });
